/**
 * In-app help and onboarding (System service, PG system DB, 2026-10).
 *
 * Mirror of `CCMSLib.Models.System.Help` (HelpModels.cs). Platform-wide help content per console page:
 * a summary, help per tab, guided tours, per-person tour progress and "Ask AI about this page".
 *
 * Keys:
 * - AppKey: "events" | "rides" | ...
 * - PageKey: "{appKey}.{page}" in kebab case, e.g. "events.event-detail".
 * - TabKey: unique within a page, e.g. "connected".
 * - Tour step `target`: a `data-help-id` value on the page; empty = a centred card.
 *
 * Help HTML is sanitised on the server (allow-list) and must be sanitised again in the browser.
 */
/** Ids of the seeded HelpTourProgressStatus lookup. */
export const HelpTourProgressStatusIds = {
    Completed: 1,
    Dismissed: 2,
};
/** Quick-action ids for Ask AI: the server fills a standard question when `question` is empty. */
export const HelpAskIntents = {
    PageOverview: 'page-overview',
    TabOverview: 'tab-overview',
    SetupSteps: 'setup-steps',
    WhatFirst: 'what-first',
    WhereIs: 'where-is',
};
/** Limits the API enforces on suggested questions. */
export const HelpLimits = {
    maxPageSuggestedQuestions: 6,
    maxTabSuggestedQuestions: 4,
    maxSuggestedQuestionLength: 80,
};
//# sourceMappingURL=Help.js.map